import React from "react";
import clsx from "clsx";
import styles from "./Line.module.css";

type LineProps = {
    direction: "horizontal" | "vertical";
    length: number;
    color?: number;
    className?: string;
};

const Line = ({ direction, length, className }: LineProps) => {
    const width = React.useMemo(
        () => (direction === "horizontal" ? `${length}px` : "1px"),
        [direction, length]
    );
    const height = React.useMemo(
        () => (direction === "vertical" ? `${length}px` : "1px"),
        [direction, length]
    );

    return (
        <div
            className={clsx(styles.root, className)}
            style={{ width, height }}
        />
    );
};

export default Line;
